declare const I18n;

import React from "react";
import LearnersCourseProgressTable from "@/components/tables/LearnersCourseProgressTable";


export const LearnersCourseProgress: React.FC = () => {
  return (
    <div>
      <div className="resource-heading-container">
        <h2 className="section-heading">
          {I18n.t("views.learners.index.tables.learners_course_progress")}
        </h2>
      </div>
      <LearnersCourseProgressTable />
    </div>)
};

export default LearnersCourseProgress;